import styled from 'styled-components';
import { layout, media, remCalc } from '@prisjakt/ui-base';

import Clickable from '@prisjakt/ui-clickable';
import UserReviewCardComponent from '../../../../../../components/user-review-card';

import { CONTENT_TITLE_SIZE } from '../../constants';

export const RatedShops = styled.section`
  margin-top: ${layout.spacing.small};
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: ${layout.spacing.small};

  ${media.mediumDown`
    grid-template-columns: 1fr;
  `};
`;

export const Main = styled.div`
  margin-bottom: ${layout.spacing.small};
  padding: 0 ${layout.spacing.xSmall};
`;

export const Sidebar = styled.div`
  padding: 0 ${layout.spacing.small};
  border-left: 1px solid ${p => p.theme.lines.primary};
`;

export const Title = styled.div`
  h3 {
    font-size: ${remCalc(CONTENT_TITLE_SIZE)};
    margin-bottom: 0;
  }

  p {
    margin-bottom: 0;
  }

  margin-bottom: ${layout.spacing.medium};
`;

export const Subtitle = styled.p`
  margin-bottom: ${layout.spacing.medium};
`;

export const ShopSection = styled.div``;

export const ReviewSection = styled.div``;

export const ShopCardWrapper = styled.div`
  padding: ${layout.spacing.xxSmall};
  width: 50%;
`;

export const ShopCard = styled(Clickable)`
  height: 104px;
  background: ${p => p.theme.bg.secondary};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  position: relative;

  &:hover {
    &::after {
      position: absolute;
      content: '';
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.02);
      z-index: 1;
      border-radius: 5px;
      pointer-events: none;
      transition: background-color 150ms ease;
    }
  }
`;

export const ShopRating = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: ${layout.spacing.xSmall};

  svg {
    margin-right: ${layout.spacing.xSmall};
  }
`;

export const UserReviewCard = styled(UserReviewCardComponent)`
  width: 100%;
  grid-template-columns: 0 1fr 0;
  font-size: ${layout.fontSizes.small.desktop.rem};
  margin-bottom: ${layout.spacing.small};
`;
